<template>
    <div class="default-container">
        <header-default></header-default>
        <router-view></router-view>
    </div>
</template>
<script>
import HeaderDefault from '../components/Sections/HeaderDefault.vue'
export default {
    components:{
        HeaderDefault
    }
}
</script>
<style lang="scss" scoped>
    .default-container{
        height: 100%;;
    }
</style>

